var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.969,
    height: 31.013,
    viewBox: "0 0 31.969 31.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print_black_24dp",
    transform: "translate(0 0.549) rotate(-1)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M0,0H31.442V30.469H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M24.549,9.416H5.979A3.911,3.911,0,0,0,2,13.266v7.7H7.306V26.1H23.222V20.965h5.306v-7.7A3.911,3.911,0,0,0,24.549,9.416ZM20.57,23.531H9.958V17.115H20.57Zm3.979-8.983a1.284,1.284,0,1,1,1.326-1.283A1.309,1.309,0,0,1,24.549,14.549ZM23.222,3H7.306V8.133H23.222Z",
    transform: "translate(0.457 0.685)",
    fill: "#f6f7fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintGrey);
export default __webpack_public_path__ + "static/media/PrintGrey.cc4b5bab62ece387d48ba74229cb57fd.svg";
export { ForwardRef as ReactComponent };